import { z } from 'zod';

/** 1–500 chars; server re-validates. Shared by every reason-bearing trainer dialog. */
export const trainerReasonSchema = z.object({ reason: z.string().min(1).max(500) });
export type TrainerReasonFormValues = z.infer<typeof trainerReasonSchema>;
